export const enum LiffActionType {
  SET_LIFF = 'SET_LIFF',
}
